
export const categoriesPt = [
    'Relatórios Anuais',
    'Políticas',
    'Posicionamentos',
    'Código de Conduta',
    'Certificações',
    'Finanças Sustentáveis',
    'Cadernos de Indicadores',
    'Outras informações'
]

export const categoriesEn = [
  'Annual Reports',
  'Policies',
  'Positioning',
  'Code of Conduct',
  'Certifications',
  'Sustainable Finance',
  'Indicators Book',
  'Additional Information'
]